// extracted by mini-css-extract-plugin
module.exports = {"speaker":"Speaker_speaker__1vRXP","photo":"Speaker_photo__3GHNp","name":"Speaker_name__ib1hr","large":"Speaker_large__2vUmc"};